/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { DialogBox } from '@mummssoftware/common-ui';
import { VisitContext } from '../Context/contexts/VisitContext';
import { ConfirmRecordVisit } from './ConfirmRecordVisit';
import defaults from '../../translations/en.json';

export const ConfirmVisitDialog = () => {
  const { showConfirmVisit } = useContext(VisitContext);

  return showConfirmVisit ? (
    <>
      <DialogBox
        title={defaults.confirmVisitTitle}
        disableBackdropClick
        open={showConfirmVisit}
        handleClick={() => null}
        noIcon
      >
        <ConfirmRecordVisit />
      </DialogBox>
    </>
  ) : (
    <></>
  );
};
